import { Box, BoxProps } from "@mui/material";
import { ReactNode, forwardRef } from "react";

import AppChip, { AppChipProps } from "../../Chip/AppChip";
import AppPopover from "../../Popover/AppPopover";
import AppPopoverContent from "../../Popover/AppPopoverContent";

export interface TableCellContentOfChipProps extends AppChipProps {
  /** Detailed content that is shown in popover when counter is hovered. */
  popoverContent?: ReactNode;
  containerProps?: Partial<BoxProps>;
}

export const defaultTableCellContentOfChipProps: TableCellContentOfChipProps = {
  variant: "filled",
  size: "large",
  color: "default",
  shape: "square",
  clickable: false,
};

/** @deprecated DRAFT */
export default forwardRef<HTMLDivElement, TableCellContentOfChipProps>(
  function TableCellContentOfChip(
    { popoverContent, containerProps, ...chipProps }: TableCellContentOfChipProps,
    ref,
  ) {
    const chipPropsComputed = { ...defaultTableCellContentOfChipProps, ...chipProps };

    return (
      <AppPopover
        enabled={!!popoverContent}
        hoverBehavior={{ closeBehavior: "onTriggerOrContentMouseLeave" }}
        trigger={
          <Box {...containerProps}>
            {!chipPropsComputed.label ? (
              "-"
            ) : (
              <AppChip
                ref={ref}
                {...chipPropsComputed}
                sx={{
                  minWidth: chipPropsComputed.size === "medium" ? 32 : undefined,
                  ...chipPropsComputed.sx,
                }}
              />
            )}
          </Box>
        }
      >
        <AppPopoverContent>{popoverContent}</AppPopoverContent>
      </AppPopover>
    );
  },
);
